// Widget Scripts
import cardWidgetOne from './js/widgets/cardWidgetOne.js';
import cardWidgetTwo from './js/widgets/cardWidgetTwo.js';
import cardWidgetThree from './js/widgets/cardWidgetThree.js';
import cardWidgetFour from './js/widgets/cardWidgetFour.js';
import cardWidgetMail from './js/widgets/cardWidgetMail.js';
import swiperWidget from './js/widgets/swiperWidget.js';
import videoWidget from './js/widgets/videoWidget.js';

// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
if (window.location.pathname === '/') {
  $(document).ready(function() {
    cardWidgetOne();
    cardWidgetTwo();
    cardWidgetThree();
    cardWidgetFour();
    cardWidgetMail();
    swiperWidget();
  });
}

$(window).load(function() {
  if ($('.homepage').length > 0) {
    videoWidget();
  }
});